<template>
    <div class="page">

        <div class="header">
            <SearchBar />
        </div>
        
        <div class="content">
            <slot></slot>
        </div>

    </div>
</template>

<script>
import SearchBar from '@/components/library/search/SearchBar.vue'

export default {
    name: 'Page',
    components: {
        SearchBar
    }
}
</script>

<style scoped>
.page {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    overflow: hidden;
}

.page .header {
    width: 100%;
    flex-shrink: 1;
}

.page .content {
    flex-grow: 1;
    display: block;
    overflow: hidden;
}
</style>